import { Flex, Spacing, Switch } from '@billy/design-system'
import { ChangeEvent, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { RequiredFieldLabel } from '../RequiredFieldLabel'

interface AccountNumberFieldLabelProps {
  disabled?: boolean
  isManualEntryEnabled: boolean
  onManualEntryChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export const AccountNumberFieldLabel = ({
  disabled,
  isManualEntryEnabled,
  onManualEntryChange,
}: AccountNumberFieldLabelProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex justifyContent="space-between">
      <span>
        <RequiredFieldLabel>{t('coa.account_from_base_form.account_number')}</RequiredFieldLabel>
      </span>
      <Flex gap={Spacing.S8}>
        {t('coa.account_from_base_form.set_manually')}
        <Switch checked={isManualEntryEnabled} disabled={disabled} onChange={onManualEntryChange} />
      </Flex>
    </Flex>
  )
}
